<template>
  <div class="empty-state">
    <div class="content">
      <icon v-if="icon" :name="icon" />

      <h3 v-if="title">{{ title }}</h3>

      <p v-if="description">{{ description }}</p>

      <slot />
    </div>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    title: String,
    description: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.empty-state {
  text-align: center;
  padding: $gp;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  max-width: 650px;
}

i {
  font-size: 100px;
  color: $color-gray-5;
  margin-bottom: $gp;

  @media($medium-down) {
    font-size: 60px;
  }
}
</style>
